<template lang="pug">
.input-container
  label.label(:class="{ 'property-modified': isPropertyModified() }") {{ nameLabel }} {{ propertyModified() }}
  input.input(v-if="index" v-model="dataForm[property][index]" :title="title" :type="type" :min="min" :max="max" :minLength="minlength" :maxlength="maxlength" :pattern="pattern" autocomplete="ño" :disabled="disabled" :required="required" @blur="$emit('blur')" @keydown.enter.prevent="$emit('keyenter')" :class="{'next-input-optional': !required}")
  input.input(v-else v-model="dataForm[property]" :title="title" :type="type" :min="min" :max="max" :minLength="minlength" :maxlength="maxlength" :pattern="pattern" autocomplete="ño" :disabled="disabled" :required="required" @blur="$emit('blur')" @keydown.enter.prevent="$emit('keyenter')" :class="{'next-input-optional': !required}")
</template>

<script>
import mPropertyManage from '@/mixins/propertyManage'

export default {
  mixins: [mPropertyManage],

  props: {
    dataOriginal: Object,
    dataForm: Object,
    nameLabel: String,
    property: String,
    index: Number,
    disabled: Boolean,
    title: String,
    type: String,
    min: String,
    max: String,
    minlength: String,
    maxlength: String,
    pattern: String,
    required: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/Input.vue